module.exports = __webpack_public_path__ + "files/adb3211a7328df81a7e1e16e8695bbd9.png";